"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../../constants");
class FavoriteSnackbar extends Marko.Component {
    handleAction() {
        switch (this.input.responseType) {
            case constants_1.RESPONSE_TYPES.WATCH_LIST_FULL:
                window.location.href = `https://${this.input.hostname}${constants_1.WATCHLIST_PAGE_PATH}`;
                break;
            case constants_1.RESPONSE_TYPES.CSRF_TOKEN_ERROR:
                location.reload();
                break;
            default:
                break;
        }
    }
    onSnackbarClose() {
        this.emit('snackbarClose');
    }
}
exports.default = FavoriteSnackbar;
